const isMobile = () => /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);

// Stampa un PDF senza lasciare schermate aperte: su desktop usa un iframe nascosto
// (si apre solo la finestra di stampa); su mobile apre il PDF e prova a chiuderlo dopo la stampa.
export const printPdfBlob = (blob) => {
  const url = window.URL.createObjectURL(blob);
  const cleanup = () => setTimeout(() => window.URL.revokeObjectURL(url), 60000);

  if (isMobile()) {
    const w = window.open(url);
    if (!w) return false;
    w.addEventListener('load', () => {
      w.addEventListener('afterprint', () => w.close());
      w.print();
    });
    cleanup();
    return true;
  }

  const iframe = document.createElement('iframe');
  iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden;';
  iframe.src = url;
  const remove = () => { iframe.remove(); window.URL.revokeObjectURL(url); };
  iframe.onload = () => {
    try {
      iframe.contentWindow.addEventListener('afterprint', () => setTimeout(remove, 500));
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    } catch {
      window.open(url);
    }
    setTimeout(remove, 10 * 60 * 1000);
  };
  document.body.appendChild(iframe);
  return true;
};

export default printPdfBlob;
